import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { getFormatObject, getViewer } from 'libs/rendering/utils';

import { useRouterStore } from 'apps/hooks';
import { useContextManager } from 'apps/context/hooks';
import { useSharedFileManager } from 'apps/share/hooks';
import { useChatControl, useViewerWidth } from 'libs/rendering/hooks';
import { frameStore } from 'apps/components/Frame/appManager';

import { ViewerControl } from 'libs/rendering/gltf/viewerControl';
import { ViewerControlProvider } from 'libs/rendering/gltf/hooks';

import { VisibilityWrapper } from 'components';

import ChatPanel from './gltf/components/chat/chatPanel';

// import { ViewerTab } from './gltf/components/tab';

export const PreviewFileViewer = observer(props => {
  const contextManager = useContextManager();
  const [viewerControl] = useState(
    () => new ViewerControl(contextManager, true),
  );

  return (
    <ViewerControlProvider value={viewerControl}>
      {props.children}
    </ViewerControlProvider>
  );
});

export const FileViewer = observer(props => {
  const routerStore = useRouterStore();
  const contextManager = useContextManager();
  const chatControl = useChatControl();
  const sharedFileManager = useSharedFileManager();

  const { file, partId, isPreview } = props;
  const partIdFromPropsOrParams = partId || routerStore.params.get('partId');

  const { formatObject } = getFormatObject(file);

  const Viewer = getViewer(formatObject);
  const shouldRenderRightPanel =
    frameStore.canShowRightPanel && !chatControl.chatVisible;

  useEffect(() => {
    frameStore.SetFile(file);
    frameStore.SetContextManager(contextManager);
    frameStore.SetSharedFileManager(sharedFileManager);
    return () => {
      frameStore.SetFile(null);
      frameStore.SetContextManager(null);
      frameStore.SetSharedFileManager(null);
    };
  }, [file, contextManager, sharedFileManager]);

  const [viewerWidth] = useViewerWidth();

  if (isPreview) {
    return (
      <PreviewFileViewer>
        {/* {formatObject.viewer !== 'GltfViewer' && <ViewerTab />} */}
        <Viewer
          isPreview={isPreview}
          file={file}
          partId={partIdFromPropsOrParams}
        />
        {shouldRenderRightPanel && props.children}
      </PreviewFileViewer>
    );
  }

  return (
    <>
      {/* {formatObject.viewer !== 'GltfViewer' && <ViewerTab />} */}
      <Viewer
        isPreview={isPreview}
        file={file}
        partId={partIdFromPropsOrParams}
        width={viewerWidth}
      />

      {/* Chat should be mounted based on whether a Context is available */}
      {contextManager && <ChatPanel />}

      <VisibilityWrapper visible={shouldRenderRightPanel}>
        {React.cloneElement(props.children, { fileFormatObject: formatObject })}
      </VisibilityWrapper>
    </>
  );
});

FileViewer.propTypes = {
  file: PropTypes.object,
  partId: PropTypes.string,
  children: PropTypes.object,
};
